import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import { distinctUntilChanged } from "rxjs/operators";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { ErrorVO } from "@vo/errorVO";

@Injectable({
  providedIn: "root",
})
export class ModaleErroreStore {
  private errore: BehaviorSubject<any>;

  constructor() {
    this.errore = new BehaviorSubject<any>(null);
  }

  public getErrori(): Observable<any> {
    return this.errore.asObservable().pipe(distinctUntilChanged());
  }

  public sendErrore(errore: any) {
    console.log("invio un errore", errore);
    const erroreVO = new ErrorVO();
    erroreVO.setErrorDetails(errore);
    this.errore.next(erroreVO);
  }

  resetErrori() {
    this.errore.next(null);
  }
}
